import React, { Component } from 'react';
import Heading from '~/UI/Heading/Heading';
import compactInputStyles from '~/UI/Input/compact.less';
import Input from '~/UI/Input/Input';
import Popover from '~/UI/Popover';

interface Props {
	link: string | null;
	referenceRect: ClientRect | null;
	onClose(event: MouseEvent): void;
}

/** Extra space below the Share trigger so the link box does not cover the button. */
const OFFSET_BELOW_REFERENCE = 12;

export default class ShareLinkPopover extends Component<Props> {
	static defaultProps = {
		link: null,
		referenceRect: null,
	};

	inputElement: Input | null = null;

	componentDidMount() {
		if (this.inputElement !== null) {
			this.inputElement.focus();
		}
	}

	render() {
		const { link, referenceRect, onClose } = this.props;

		if (!referenceRect) {
			return null;
		}

		// DOMRect getters are not enumerable — do not spread; copy fields explicitly.
		const offsetReferenceRect: ClientRect = {
			top: referenceRect.top + OFFSET_BELOW_REFERENCE,
			bottom: referenceRect.bottom + OFFSET_BELOW_REFERENCE,
			left: referenceRect.left,
			right: referenceRect.right,
			width: referenceRect.width,
			height: referenceRect.height,
			x: referenceRect.x,
			y: referenceRect.y + OFFSET_BELOW_REFERENCE,
			toJSON: referenceRect.toJSON.bind(referenceRect),
		};

		return (
			<Popover referenceRect={offsetReferenceRect} width={320} onClose={onClose}>
				<Heading level={5}>Link</Heading>
				<Input
					readOnly
					name='share-link'
					ref={(ref) => (this.inputElement = ref)}
					styles={compactInputStyles}
					type='text'
					value={link === null ? window.location.href : link}
					onClick={this.selectAllText}
					onFocus={this.selectAllText}
				/>
			</Popover>
		);
	}

	selectAllText = () => {
		if (this.inputElement) {
			this.inputElement.selectAllText();
		}
	};
}
